
import { Button } from "@/components/ui/button";
import { Laptop, Tablet, Smartphone } from "lucide-react";

export type DeviceSize = 'desktop' | 'tablet' | 'mobile';

type PreviewDeviceControlsProps = {
  deviceSize: DeviceSize;
  onDeviceSizeChange: (size: DeviceSize) => void;
};

export const PreviewDeviceControls = ({ deviceSize, onDeviceSizeChange }: PreviewDeviceControlsProps) => {
  return (
    <div className="flex items-center gap-1">
      <Button
        variant={deviceSize === 'desktop' ? 'secondary' : 'ghost'}
        size="sm"
        onClick={() => onDeviceSizeChange('desktop')}
        title="Desktop view"
        className="text-xs"
      >
        <Laptop className="w-3.5 h-3.5" />
      </Button>
      <Button
        variant={deviceSize === 'tablet' ? 'secondary' : 'ghost'}
        size="sm"
        onClick={() => onDeviceSizeChange('tablet')}
        title="Tablet view"
        className="text-xs"
      >
        <Tablet className="w-3.5 h-3.5" />
      </Button>
      <Button
        variant={deviceSize === 'mobile' ? 'secondary' : 'ghost'}
        size="sm"
        onClick={() => onDeviceSizeChange('mobile')}
        title="Mobile view"
        className="text-xs"
      >
        <Smartphone className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
};

export const getPreviewWidth = (deviceSize: DeviceSize) => {
  switch (deviceSize) {
    case 'mobile':
      return 'w-[375px]';
    case 'tablet':
      return 'w-[768px]';
    default:
      return 'w-full';
  }
};
